// The API serializes enums as their C# member names (JsonStringEnumConverter),
// so these values are the strings that actually arrive over the wire.
export enum CtVtRating {
    CT = 'CT',
    VT = 'VT',
}

export interface DtMeterType {
    id: number;
    type: string;
    dtMeterBrandId: string;
    utilityId: number;
    rating: CtVtRating[];
}

export function getInitDtMeterType(): DtMeterType{
    return {
        id: 0,
        type: '',
        dtMeterBrandId: '',
        utilityId: 0,
        rating: []
    }
}